// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sm-c";
export var backButton = "_sm-4";
export var backIcon = "_sm-5";
export var chevronShortcut = "_sm-6";
export var container = "_sm-1";
export var editor = "_sm-8";
export var editorWrapper = "_sm-7";
export var prefix = "_sm-2";
export var searchIcon = "_sm-3";
export var suffix = "_sm-9";
export var suffixContent = "_sm-a";
export var suffixText = "_sm-b";
export var wrapper = "_sm-0";